// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IAddTemporarilyRequest,
  TAddTemporarilyModel,
  IMappers,
  TAddTemporarilyResponse_,
  TAddTemporarilyResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IAddFileResponse } from '../../entities/Models/AddFileResponse';

export function createAddTemporarilyModel(parameters: IAddTemporarilyRequest): TAddTemporarilyModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'encrypted-file-manager',
    pathApi: '/v2/add-temporarily/',
    response: {
      200: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'formData',
      parameters,
    },
  };
}

export const defaultConfig = createAddTemporarilyModel({} as unknown as IAddTemporarilyRequest);

export interface IAddTemporarilyOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IAddTemporarilyRequest;
}

export async function fetchAddTemporarily<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddTemporarilyOptions<TResponse200>): Promise<TAddTemporarilyResponse | TResponse200> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddTemporarilyModel(parameters),
    config,
  )) as FetchResponse<TAddTemporarilyResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFileResponse, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TAddTemporarilyResponse;
}
